var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { StatusCode } from "../ajax/statusCode";
var JSONResponse = /** @class */ (function () {
    function JSONResponse(ajaxResponse) {
        this._status = ajaxResponse.status;
        this._data = this.parse(ajaxResponse.response);
    }
    Object.defineProperty(JSONResponse.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSONResponse.prototype, "succeeded", {
        get: function () {
            return StatusCode.IsSuccess(this._status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSONResponse.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    JSONResponse.prototype.parse = function (json) {
        try {
            var response = JSON.parse(json);
        }
        catch (e) {
            response = null;
        }
        return response === null ?
            {} :
            response;
    };
    return JSONResponse;
}());
function createEntityResponseFactory(convert) {
    return function (response) {
        return new EntityResponseClass(response, convert);
    };
}
var EntityResponseClass = /** @class */ (function (_super) {
    __extends(EntityResponseClass, _super);
    function EntityResponseClass(ajaxResponse, convert) {
        var _this = _super.call(this, ajaxResponse) || this;
        if (_this.succeeded) {
            if (_this.data != null) {
                var entity = _this.data.entity;
                _this.data = __assign(__assign({}, _this.data), { entity: convert(entity) });
            }
        }
        return _this;
    }
    return EntityResponseClass;
}(JSONResponse));
function createCollectionResponseFactory(convert) {
    return function (response) {
        return new CollectionResponseClass(response, convert);
    };
}
var CollectionResponseClass = /** @class */ (function (_super) {
    __extends(CollectionResponseClass, _super);
    function CollectionResponseClass(ajaxResponse, convert) {
        var _this = _super.call(this, ajaxResponse) || this;
        if (_this.succeeded) {
            if (_this.data != null) {
                var collection = _this.data.collection;
                var result_1 = [];
                collection.forEach(function (element) {
                    result_1.push(convert(element));
                });
                _this.data = __assign(__assign({}, _this.data), { collection: result_1 });
            }
        }
        return _this;
    }
    return CollectionResponseClass;
}(JSONResponse));
export { JSONResponse, createEntityResponseFactory, createCollectionResponseFactory, };
